import {useEffect, useState} from 'react';
import {subscribeToNotifications} from '../services/notificationsApi';

export const useNotifications = (edgeId) => {
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (!edgeId) return undefined;

    const unsubscribe = subscribeToNotifications(
      edgeId,
      (items) => setNotifications(items),
      (err) => console.error('Notifications listener failed:', err),
    );

    return () => unsubscribe();
  }, [edgeId]);

  return {notifications};
};
